import { routes } from '@config/index';
import { api } from '../api/api';
export function requestAnalyzation(data, signal) {
    return api.post(routes.apiEndpoints.analyzer(), JSON.stringify(data), signal);
}
